import React from 'react';
import TextField from '@mui/material/TextField';

import Paper from '@mui/material/Paper';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import ListItemText from '@mui/material/ListItemText';
import ListItemSecondaryAction from '@mui/material/ListItemSecondaryAction';


import Grid from '@mui/material/Grid';

import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import EditIcon from '@mui/icons-material/Edit';
import Tooltip from '@mui/material/Tooltip';

import speziesEntity from '../Entity/Kennzeichnung/Spezies';
import WebServiceGet from '../Connectors/WebServiceGet';
import { ContactSupportOutlined } from '@mui/icons-material';

const styles={
  warning:{
    margin:"0 20px 20px 20px",
    padding:"15px",
    backgroundColor:'#fcffc9',
    border:"1px solid #e2e2e1",
    transition: "border-color 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
    borderBottom: "1px solid rgba(0, 0, 0, 0.42)",
  },
  lightBackground: {
    border:"1px solid #C4C4C4",
  },
}

export default class Spezies extends React.Component {

  state = {
    name:'',
    hilfeAktiv:false,
    arrSpezies:[],
  }

  ladeSpezies = (suchbegriff='') => {
    WebServiceGet(
      this.props.restLadeSpezies,
      suchbegriff,
      (data) => {
        this.setState({arrSpezies:data})
      }
    )
  }
  
  hilfeAktivieren = () => {
    this.setState({hilfeAktiv:true})
  }

  hilfeSchliessen = () => {
    this.setState({hilfeAktiv:false})
  }

  speziesSelected = () => {
    if ( !this.props.spezies ) {
      return false  
    }

    if ( !this.props.spezies.hasOwnProperty('de') ) {
      return false  
    }

    if ( this.props.spezies.de || this.props.spezies.wiss ) {
      return true
    }
    return false
  }

  anhang = () => {
    return '';
    if ( this.props.spezies.anhangA) {
      return "(Anhang A)"
    }
    if ( this.props.spezies.anhangB) {
      return "(Anhang B)"
    }
  }

  floraOderFauna = () => {
    if ( this.props.spezies.istFlora) {
      return " (Flora)"
    }
    if ( this.props.spezies.istFauna) {
      return " (Fauna)"
    }
  }

  secondaryTextSpezies = () => {
    return (
      <span>
        <span style={{color:"black"}}>{this.props.spezies.de}</span><br/>
        {this.props.spezies.einordnung.map(term => (
          <span style={{marginRight:'10px'}} key={term}>{term}</span>
        ))}
        {this.anhang()}
        {this.floraOderFauna()}
      </span>
    )
  }

  selectedSpezies = () => {
    if ( !this.speziesSelected() ) {
      return null
    }

    return (
      <div
        style={{...styles.lightBackground,...{borderRadius:"5px"}}}
      >
        <List>
        <ListItem
          button={false}
          onClick={()=>{}/*() => this.props.dispatchSpezies(speziesEntity())*/}
        >
          {this.props.zeigeAnzahl &&
          <ListItemAvatar
            style={{paddingLeft:"0px", paddingRight:"14px"}}
          >
            <TextField
              label="Anzahl"
              fullWidth={true}
              style={{width:"65px"}}
              value={this.props.anzahl}
              type="tel"
              inputProps={
                {
                  style: { textAlign: 'center' },
                  autoComplete: "off"
                }
              }
              onChange={(e)=>{
                this.props.dispatchAnzahl(e.target.value)
              }}
            />

          </ListItemAvatar>
          }
          <ListItemText
            primary={this.props.spezies.wiss}
            secondary={this.secondaryTextSpezies()}
          />
          <ListItemSecondaryAction>
            <Tooltip title="Spezies ändern">
              <IconButton sx={{ '& .MuiSvgIcon-root': { fontSize: 28 }}} 
                aria-label="bearbeiten"
                edge="end"
                onClick={() => this.props.dispatchSpezies(speziesEntity())}
              >
                <EditIcon />
              </IconButton>
            </Tooltip>
          </ListItemSecondaryAction>
        </ListItem>
        </List>
        {this.speziesSelected() && this.props.spezies.wiss.search("spp") > -1 &&
          <div style={styles.warning}>
            Sie haben eine <b><i>species pluralis</i></b> (spp) ausgewählt. 
            Bitte geben Sie eine möglichst konkrete Art/Spezies an.
            Wählen Sie nur dann eine <i>species pluralis</i> aus, wenn 
            eine genauere Zuordnung nicht möglich ist.
          </div>
        }
      </div>
    )
  }

  mapListe = () => {
    var increment = 0
    if (this.speziesSelected()) {
      return null
    }

    return this.state.arrSpezies.map(
      (obj) => {
        increment+= 1
        return (
          <ListItem
            button
            key={increment+obj.wiss}
            onClick={
              () => {
                this.props.dispatchSpezies(obj)
              }
            }
          >
          <ListItemText
            primary={obj.wiss}
            secondary={obj.de}
          />
        </ListItem>
        )
      }
    )
  }

  render () {
    if ( !this.speziesSelected() ) {
      return(
        <Grid container spacing={2}>
          <Grid item md={4} xs={12}>
            <TextField
              id="SpeziesAC"
              value={this.state.name}
              label="Artname"
              placeholder="Deutscher oder wissenschaftlicher Artname"
              error={(
                ()=>(this.props.spezies.touched && !this.props.spezies.wiss)
                ? true
                : false
              )()}
              inputProps={
                {
                  autoComplete: "off"
                }
              }
              onChange={
                (e) => {
                  this.ladeSpezies(e.target.value)
                  this.setState({name:e.target.value})
                }
              }
              onBlur={
                ()=>{
                  this.props.updaterTouched(true)
                }
              }
              margin="normal"
              fullWidth
            />
          </Grid>
          <Grid item md={8} xs={12}>
            {this.state.name && this.state.arrSpezies.length > 0 &&
              <Paper style={{marginTop:'3px', marginBottom:'3px', maxHeight:'400px', overflowY:'scroll'}}>
                <List>
                  {this.mapListe()}
                </List>
              </Paper>
            }
            {this.state.name && this.state.arrSpezies.length < 1 &&
            <Paper style={{marginTop:'3px', marginBottom:'3px', padding:"15px"}}>
              <p>Die eingegebene Spezies <b style={{borderBottom:"1px solid red"}}>{this.state.name}</b> wurde nicht erkannt. Bitte wählen Sie eine Spezies aus der Liste aus.</p>
              <p>Falls Sie in der Liste nicht fündig werden, sich aber sicher sind, die Spezies korrekt eingegeben zu haben, übernehmen Sie Ihre Eingabe.</p>
              <Button
                onClick={
                  () => {
                    let spz = speziesEntity()
                    spz.wiss = this.state.name
                    spz.de = "-"
                    this.props.dispatchSpezies(spz) 
                  }
                }
              >
                Eigene Eingabe übernehmen
              </Button>

            </Paper>
            }
          </Grid>
        </Grid>
      )
    }

    return (
      <Grid container spacing={2}>
          <Grid item xs={12}>
            {this.selectedSpezies()}
          </Grid>
        </Grid>
    )
  }

}
